import http from './http'

export const $http = http
